"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _Item = require("./Item.js");

var _Item2 = _interopRequireDefault(_Item);

var _Category = require("./Category.js");

var _Category2 = _interopRequireDefault(_Category);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

var items = null;
var categories = null;
var baseTime = null;

self.buildForMenu = function (params) {
    var time = params.time;
    var menu = params.menu || {};

    items = {};
    categories = {};

    baseTime = time.clone();

    var _items = menu.items || [];
    var _categories = menu.categories || [];

    _lodash2.default.each(_items, function (item) {
        items[item.id] = _Item2.default.getStatus(item, time);
    });
    _lodash2.default.each(_categories, function (category) {
        categories[category.id] = _Item2.default.getStatus(category, time);
    });
};

self.getStatusForItem = function (params) {
    var item = params.item;
    var time = params.time;

    var cache = (items || {})[item.id];

    var useCache = true;

    if (!cache) useCache = false;else if (!baseTime) useCache = false;else if (time.valueOf() < baseTime.valueOf()) useCache = false;else if (time.tz() !== baseTime.tz()) useCache = false;else if (cache.until < time.valueOf()) useCache = false;

    if (useCache) return cache;

    return _Item2.default.getStatus(item, time);
};

self.getStatusForCategory = function (params) {
    var category = params.category;
    var time = params.time;

    var cache = (categories || {})[category.id];
    var useCache = true;

    if (!cache) useCache = false;else if (!baseTime) useCache = false;else if (time.valueOf() < baseTime.valueOf()) useCache = false;else if (time.tz() !== baseTime.tz()) useCache = false;else if (cache.until < time.valueOf()) useCache = false;

    if (useCache) return cache;

    return _Category2.default.getStatus(category, time);
};

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/CachedStatus.js
// module id = 459
// module chunks = 0